import PropTypes from 'prop-types';
import cn from "../../../../../utils/cn";
import { isEmpty } from 'lodash';
import Divider from "../../../Divider/Divider";
import ContactInformation from "../../../Contact/ContactInformation/ContactInformation";
import DraftEditorField from "../../../../Form/DraftEditorField/DraftEditorField";
import ServiceTypes from "../../../ServiceTypes/ServiceTypes";
import { FormattedMessage } from 'react-intl';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ProgramDescription = props => {
  const {
    className = '',
    program: {
      description,
      email_addresses,
      phone_numbers,
      service_types,
      website_url
    },
    showMore = false
  } = props;
  const showContactInfo = !isEmpty(email_addresses) || !isEmpty(phone_numbers) || !isEmpty(website_url);
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [!isEmpty(service_types) && /*#__PURE__*/_jsx(ServiceTypes, {
      serviceTypes: service_types
    }), showMore && /*#__PURE__*/_jsxs("div", {
      className: cn({
        hidden: !description
      }),
      children: [!isEmpty(service_types) ? /*#__PURE__*/_jsx(Divider, {
        className: "-mx-5"
      }) : null, showContactInfo && /*#__PURE__*/_jsx(ContactInformation, {
        className: "my-5",
        email_addresses: email_addresses,
        headerText: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "hBX91R",
          description: "contact-information",
          defaultMessage: "Program Contact Information"
        }),
        phone_numbers: phone_numbers,
        showMore: showMore,
        website_url: website_url
      }), /*#__PURE__*/_jsx("h4", {
        className: "mb-2 font-heavy-font",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "rT7jXR",
          description: "description-label",
          defaultMessage: "Description"
        })
      }), /*#__PURE__*/_jsx(DraftEditorField, {
        className: "mb-8",
        hideLabel: true,
        id: "program-description-text",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "rT7jXR",
          description: "description-label",
          defaultMessage: "Description"
        }),
        readOnly: true,
        value: description
      })]
    })]
  });
};
ProgramDescription.propTypes = {
  className: PropTypes.string,
  program: PropTypes.shape({
    description: PropTypes.string,
    email_addresses: PropTypes.array,
    phone_numbers: PropTypes.array,
    service_types: PropTypes.array,
    website_url: PropTypes.string
  }).isRequired,
  showMore: PropTypes.bool
};
export default ProgramDescription;
//# sourceMappingURL=ProgramDescription.js.map